import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=32220ab8&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32220ab8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32220ab8')) {
      api.createRecord('32220ab8', component.options)
    } else {
      api.reload('32220ab8', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=32220ab8&scoped=true", function () {
      api.rerender('32220ab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Users/Register.vue"
export default component.exports